import PropTypes from 'prop-types';
import loadable from '@loadable/component';

const FacetRangeSlider = loadable(() =>
  import(/* webpackChunkName: "range-slider" */ '../attributes/facet_range_slider')
);

const { LP } = window;

const FacetLexileMeasures = ({ facets, panelId, context }) => {
  const lexileMeasures = facets.lexile_measures;
  const [lexileMeasureFacet] = lexileMeasures;

  const getRangeValues = (lexile) => {
    if (lexile.id) {
      return lexile.id.split('-');
    }

    return lexile.defaults;
  };

  const defaultRange = (e) => {
    const { defaults } = facets.lexile_measures[0];

    return (
      e.value[0] === parseInt(defaults[0], 10) && e.value[1] === parseInt(defaults[1], 10)
    );
  };

  const handleChange = (e) => {
    const facet = context.getStore('FacetStore').get('lexile_measures')[0];

    if (defaultRange(e)) {
      facet.active = true;
    } else {
      facet.active = false;
    }
    facet.id = `${e.value[0]}-${e.value[1]}`;
    facet.onClearAll = false;

    context.executeAction(LP.module('Searches').SearchActions.toggleFacet, {
      facet
    });
  };

  if (lexileMeasures.length > 0 || lexileMeasures.id) {
    const rangeValues = getRangeValues(lexileMeasureFacet);
    const minValue = parseInt(rangeValues[0], 10);
    const maxValue = parseInt(rangeValues[1], 10);
    const headerMin = `Min (${minValue}L)`;
    const headerMax = `Max (${maxValue}L)`;

    return (
      <FacetRangeSlider
        idSuffix="lexile"
        minValue={minValue}
        maxValue={maxValue}
        defaultMin={parseInt(lexileMeasureFacet.defaults[0], 10)}
        defaultMax={parseInt(lexileMeasureFacet.defaults[1], 10)}
        headerMin={headerMin}
        headerMax={headerMax}
        active={lexileMeasureFacet.active}
        range={true}
        step={10}
        panelId={panelId}
        tooltip_split={true}
        onClearAll={lexileMeasureFacet.onClearAll}
        onChange={handleChange}
      />
    );
  }

  return null;
};

FacetLexileMeasures.propTypes = {
  facets: PropTypes.object,
  panelId: PropTypes.string,
  context: PropTypes.object
};

export default FacetLexileMeasures;
